@let boundData = bound();
@let cityNames = cityNameByLocationCode();
@let tails = tailNames();

<div class="flex flex--space-between">
  <h3 class="font-heading-5 font-title-small flex flex--wrap flex--middle g-xxsmall">
    <span>{{ cityNames[boundData.departure.locationCode] }}</span>
    @for (leg of journeyLegs(); track $index) {
      <fcom-icon [name]="leg.icon"></fcom-icon>
      @if (leg.transferLocationCode) {
        <span class="font-body-1 font-body-medium regular-type" data-testid="transfer-location-code">{{
          leg.transferLocationCode
        }}</span>
      }
    }
    <span>{{ cityNames[boundData.arrival.locationCode] }}</span>
  </h3>
  <fcom-icon-button
    [icon]="{ name: SvgLibraryIcon.INFO }"
    [size]="IconButtonSize.SMALL"
    [aria]="{
      label: 'shoppingCart.viewAllFlightDetailsAria' | finLocalization,
    }"
    (clickBtn)="openItineraryDetails.emit()"
  ></fcom-icon-button>
</div>
<span class="font-body-1 font-body-medium">{{ boundData.departure.dateTime | finDateFormat: 'FULL_NO_YEAR' }}</span>
<span class="font-body-1 bold-type font-body-medium-bold">
  {{ boundData.departure.dateTime | finTime }}–{{ boundData.arrival.dateTime | finTime }}
</span>
@if (boundData.duration) {
  <span class="font-body-1 font-body-medium nowrap" data-testid="bound-duration">
    · {{ 'bookingSearch.duration' | finLocalization: (boundData.duration | finTemporaryDurationPipe) }}
  </span>
}
<span class="font-body-1 font-body-medium nowrap" data-testid="bound-stops">
  · {{ stopsLabelKey() | finLocalization: [transferCount()] }}
</span>
<div class="flex">
  @if (tails.length) {
    <div class="flex--nogrow flex ms-xxsmall-b" aria-hidden="true">
      @for (tail of tails; track tail; let first = $first) {
        <div class="flex--nogrow tail {{ tail }}" [class.first]="first" [class.minus-margin]="!first"></div>
      }
    </div>
  }
  @if (boundData.uniqueAirlineNames.length) {
    <div class="flex--nogrow overflow-hidden font-body-2 font-body-small">
      <span class="is-vishidden"> {{ 'bookingSummary.operatedBy' | finLocalization }} </span>
      {{ boundData.uniqueAirlineNames.join(', ') }}
    </div>
  }
</div>
